<template>
  <div class="exam-review">
    <div class="container px-2 px-md-1 px-lg-3 px-xl-5">
      <!-- TOP ROW -->
      <router-link :to="{ name: 'SchoolDashboardPendingExam' }" class="top-row">
        <div class="back-btn pointer">
          <div class="icon icon-caret-left"></div>
          <div class="text">Back</div>
        </div>
      </router-link>

      <!-- BODY -->
      <div class="body-row">
        <div class="exam-info-row font-weight-600">
          <div class="meta brand-tonic mgb-5 brand_tonic">REVIEW QUESTIONS</div>
          <div class="title-text brand_navy">{{ assessment_title }}</div>
        </div>

        <!-- CONTENT BLOCK -->
        <div class="content-block mb-5">
          <div class="left-content">
            <template v-if="questions.length">
              <exam-question-card
                v-for="(question, index) in questions"
                :key="index"
                :counter="index + 1"
                :question="question"
                @remove-question="removeQuestion"
              />
            </template>

            <template v-else>
              <exam-question-default-card />
              <exam-question-default-card />
              <exam-question-default-card />
              <exam-question-default-card />
              <exam-question-default-card />
            </template>
          </div>

          <div class="right-content">
            <exam-question-info-card
              :assessment_data="assessment_data"
              :alternative_details="getHomeworkDetails"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bgColorSetter } from "@/scripts/utilities";
import ExamQuestionCard from "@/components/schoolComps/dashboard/home/ExamQuestionCard";
import ExamQuestionDefaultCard from "@/components/schoolComps/dashboard/home/ExamQuestionDefaultCard";
import ExamQuestionInfoCard from "@/components/schoolComps/dashboard/home/ExamQuestionInfoCard";

export default {
  name: "ExamReview",

  components: {
    ExamQuestionDefaultCard,
    ExamQuestionCard,
    ExamQuestionInfoCard,
  },

  props: {
    assessment_data: {
      type: Object,
    },
  },

  computed: {
    getHomeworkDetails() {
      return this.details ?? {};
    },
  },

  data() {
    return {
      assessment_title: this.$route.query.title,
      questions: [],
      details: {},
    };
  },

  mounted() {
    bgColorSetter("#f5f5f5");
    this.fetchPendingQuestions();

    console.log("Props gotten", this.assessment_data);
  },

  methods: {
    ...mapActions(["getPendingExamQuestions", "removePendingExamQuestion"]),

    fetchPendingQuestions() {
      this.getPendingExamQuestions(this.$route.params.id)
        .then((response) => {
          console.log(">>", response);
          if (response.code === 200) {
            this.questions = response.data.questions;
            this.details = response.data.homework;
          } else this.questions = [];
        })
        .catch((err) => {
          console.log(err);
          this.questions = [];
        });
    },

    removeQuestion(question_id) {
      console.log(question_id);

      let payload = {
        homework_id: Number(this.$route.params.id),
        question_id,
      };

      console.log(payload);

      this.removePendingExamQuestion(payload)
        .then((response) => {
          if (response.code === 200) {
            this.questions = this.questions.filter(
              (question) => question.id !== question_id
            );
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.top-row {
  @include flex_row_start_nowrap;
  margin-top: 30px;
  margin-bottom: 50px;

  .back-btn {
    @include flex_row_center_nowrap;
    width: max-content;
    border-radius: 25px;
    padding: 10px 21px;
    border: 1px solid #e5e5e5;
    color: $brand_navy;
    font-size: 14px;
    background: #fff !important;
    transition: all 0.4s ease-in-out;

    .icon {
      margin-right: 18px;
      transition: all 0.4s ease-in-out;
    }

    .text {
      transition: all 0.4s ease-in-out;
      font-weight: 500;
    }

    &:hover {
      background: $brand_navy !important;
      .icon {
        color: $color_white;
      }
      .text {
        color: $color_white;
      }
    }
  }
}

.body-row {
  .exam-info-row {
    margin-bottom: 30px;

    .meta {
      font-size: 14px;
      line-height: 19px;
    }

    .title-text {
      font-size: 26px;
      line-height: 38px;
    }
  }

  .content-block {
    @include flex_row_between_wrap;
    align-items: flex-start;

    .left-content {
      width: 60%;

      @include breakpoint_max(xl) {
        width: 62.5%;
      }

      @include breakpoint_max(md) {
        width: 100%;
        margin-bottom: 20px;
      }
    }

    .right-content {
      width: 35%;

      @include breakpoint_max(md) {
        width: 100%;
      }
    }
  }
}
</style>
